import { useState, useEffect } from "preact/hooks";
import { FunctionComponent } from "preact";

interface CountdownTimerProps {
  expiresAt: string;
}

export const CountdownTimer: FunctionComponent<CountdownTimerProps> = ({
  expiresAt,
}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(expiresAt).getTime() - new Date().getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [expiresAt]);

  return (
    <div className="flex flex-col items-center gap-1 text-white backdrop-blur-xs bg-white/30 px-4 py-2 rounded-lg shadow-lg">
      {/* <span className="font-medium text-sm">Offer Expires In:</span> */}
      <div className="flex gap-2 font-bold">
        {timeLeft.days > 0 && (
          <div className="flex flex-col items-center">
            <span className="text-xl">{timeLeft.days}</span>
            <span className="text-xs">days</span>
          </div>
        )}
        <div className="flex flex-col items-center">
          <span className="text-xl">
            {String(timeLeft.hours).padStart(2, "0")}
          </span>
          <span className="text-xs">hours</span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-xl">
            {String(timeLeft.minutes).padStart(2, "0")}
          </span>
          <span className="text-xs">mins</span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-xl">
            {String(timeLeft.seconds).padStart(2, "0")}
          </span>
          <span className="text-xs">secs</span>
        </div>
      </div>
    </div>
  );
};
